import { render, staticRenderFns } from "./ATXPanel.vue?vue&type=template&id=52f98c04&scoped=true&"
import script from "./ATXPanel.vue?vue&type=script&lang=js&"
export * from "./ATXPanel.vue?vue&type=script&lang=js&"
import style0 from "./ATXPanel.vue?vue&type=style&index=0&id=52f98c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f98c04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VCardTitle,VIcon})
